"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var storage = new _GatewayService["default"]('shared-storage-service');
var headers = {
  'Content-Type': 'application/json'
}; // parse the fileKeys out of keys of the form :prefix/:fileKey/:userKey/:classKey

var parseRecordKey = function parseRecordKey(fullFileKey, prefix, classKey, userKey) {
  var partsToRemove = prefix.split('/');
  partsToRemove.push(classKey, userKey);
  var keyParts = fullFileKey.split('/'); // This should contain at least a userKey, classKey and fileKey

  if (keyParts.length < 3) {
    throw new Error("Failed to parse shared-storage-service key ".concat(fullFileKey));
  }

  var filteredParts = keyParts.filter(function (part) {
    return !partsToRemove.includes(part);
  });
  var recordUserKey = userKey ? userKey : filteredParts.pop();
  var fileKey = filteredParts.join('/');
  return {
    classKey: classKey,
    fileKey: fileKey,
    userKey: recordUserKey
  };
};

var fetchUserSharedStorage = function fetchUserSharedStorage(classKey, userKey, fileKey) {
  return storage.get("shared/".concat(classKey, "/").concat(userKey, "/").concat(fileKey), {
    headers: headers
  });
};

var saveToSharedStorage = function saveToSharedStorage(classKey, userKey, fileKey, data) {
  return storage.post("shared/".concat(classKey, "/").concat(userKey, "/").concat(fileKey), data, {
    headers: headers
  });
};

var listSharedStorageByPrefix = function listSharedStorageByPrefix(classKey, prefix) {
  return storage.get("shared/".concat(classKey, "/list/").concat(prefix), {
    headers: headers
  }).then(function (response) {
    return response.map(function (key) {
      var parsedKeys = parseRecordKey(key, prefix, classKey);
      return {
        userKey: parsedKeys.userKey,
        fileKey: parsedKeys.fileKey
      };
    });
  });
};

var fetchSharedStorageByUserAndPrefix = function fetchSharedStorageByUserAndPrefix(classKey, userKey, prefix) {
  return storage.get("shared/".concat(classKey, "/").concat(userKey, "/all/").concat(prefix), {
    headers: headers
  }).then(function (response) {
    return Object.keys(response).reduce(function (result, key) {
      var parsedKeys = parseRecordKey(key, prefix, classKey, userKey);
      result[parsedKeys.fileKey] = response[key];
      return result;
    }, {});
  });
};

var _default = {
  fetchUserSharedStorage: fetchUserSharedStorage,
  saveToSharedStorage: saveToSharedStorage,
  listSharedStorageByPrefix: listSharedStorageByPrefix,
  fetchSharedStorageByUserAndPrefix: fetchSharedStorageByUserAndPrefix
};
exports["default"] = _default;